import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-physician-modal',
  templateUrl: './physician-modal.component.html',
  styleUrls: ['./physician-modal.component.scss'],
})
export class PhysicianModalComponent implements OnInit {
  constructor(private _dialogRef: MatDialogRef<PhysicianModalComponent>) {}

  ngOnInit(): void {}

  close() {
    this._dialogRef.close();
  }
}
